import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onAddNewAccount = action("onAddNewAccount", event => ({
    event,
    owaType: "addNewAccount",
})) as OwaNovaActionUnion<"addNewAccount">;
